import { render, staticRenderFns } from "./snackBar.vue?vue&type=template&id=f2b626f8&scoped=true&"
import script from "./snackBar.vue?vue&type=script&lang=js&"
export * from "./snackBar.vue?vue&type=script&lang=js&"
import style0 from "./snackBar.vue?vue&type=style&index=0&id=f2b626f8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2b626f8",
  null
  
)

export default component.exports